/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.32.0
 * @since 1.32.0
 */

import { IWizardImportSubscribersLimitsTranslation } from '../../types';

export const initWizardImportSubscribersLimitsTranslation: IWizardImportSubscribersLimitsTranslation = {
    title: '',
    table: {
        date: '',
        limit: '',
        msisdn: '',
        status: '',
        warning: '',
    },
    steps: {
        LimitsDocumentSelectionStep: '',
        LimitsConfirmImportStep: '',
    },
    error: {
        codes: {},
        defaultMessage: '',
    },

    validateErrors: {
        file: '',
        foundMsisdnsCount: '',
    },

    LimitsDocumentSelectionStep: {
        attachError: {
            codes: {},
        },
        chooseFile: '',
        info: '',
        maxImportSubs: '',
        readMore: '',
        readLess: '',
        template: '',
        templateUrl: '',
        title: '',
        warning: '',
    },
    LimitsConfirmImportStep: {
        counterLabel: '',
        exportButton: '',
        exportModal: {
            closeButton: '',
            exportButton: '',
            info: '',
            title: '',
        },
        status: {
            conflictTitle: '',
            error: '',
            success: '',
        },
    },
};
